import { createGlobalStyle } from "styled-components";
import GOTHAM_MEDIUM_2 from "./GOTHAM-MEDIUM_2.OTF";
import GOTHAM_BOLD_3 from "./GOTHAM-BOLD_3.OTF";
import GOTHAM_LIGHT_2 from "./GOTHAM-LIGHT_2.OTF";
import GOTHAM_BOOK_2 from "./GOTHAM-BOOK_2.OTF";
import GOTHAM_XLIGHT_4 from "./GOTHAM-XLIGHT_4.OTF";
const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Gotham-Medium;
    src: url(${GOTHAM_MEDIUM_2}) format('OpenType');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: Gotham-Bold;
    src: url(${GOTHAM_BOLD_3}) format('OpenType');
    font-weight: normal;
    font-style: normal;
    font-display: swap;

  }
  @font-face {
    font-family: Gotham-Light;
    src: url(${GOTHAM_LIGHT_2}) format('OpenType');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: Gotham-Book;
    src: url(${GOTHAM_BOOK_2}) format('OpenType');
    font-weight: normal;
    font-style: normal;
    font-display: swap;    
  }
 
  @font-face {
    font-family: Gotham-xLight;
    src: url(${GOTHAM_XLIGHT_4}) format('OpenType');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
 

 
`;
export default GlobalStyle;
